/*
import { Grupo } from "./models"

export default {
  SET_GRUPOS(state: any, grupos: Grupo[]) {
    state.grupos = grupos
  },

  SET_LOADING(state: any, value: boolean) {
    state.loading = value
  }
}
*/
import { Mutations } from "vuex-smart-module"
import GruposState from "./state"
import { Grupo } from "./models"

export default class GruposMutations extends Mutations<GruposState> {

  setGrupos(grupos: Grupo[]) {
    this.state.grupos = grupos
  }

  setLoading(value: boolean) {
    this.state.loading = value
  }
}